import { get } from '@classic/Foundation/Services/ApiService'
import type { Tabs, TicketResponseData } from '@core/Areas/AccountActivity/types'

export const fetchPendingTicketsData = ({
  activeTab,
  isOrderByEventStart,
  nextPage,
  selectedDate,
}: {
  activeTab: Tabs
  isOrderByEventStart: boolean
  nextPage: string | null
  selectedDate?: string
}) => {
  const url = buildDataUrl({ activeTab, isOrderByEventStart, nextPage, selectedDate })
  return get<TicketResponseData>({ url })
}

// =============
// Local Helpers
// =============

function buildDataUrl({
  activeTab,
  isOrderByEventStart,
  nextPage,
  selectedDate,
}: {
  activeTab: Tabs | null
  isOrderByEventStart: boolean
  nextPage: string | null
  selectedDate?: string
}): string {
  const apiUrlBase = '/$_/accountActivity'

  let optionalHeadQuery = ''
  switch (activeTab) {
    case 'pending': {
      optionalHeadQuery = !nextPage ? '?isOrderByEventDate=' + isOrderByEventStart : ''
      break
    }
    case 'results': {
      optionalHeadQuery = !nextPage
        ? `?isOrderByEventDate=${isOrderByEventStart}` +
          (selectedDate ? `&selectedDate=${selectedDate}` : '')
        : ''
      break
    }
    case 'transactions': {
      optionalHeadQuery = selectedDate ? `?selectedDate=${selectedDate}` : ''
      break
    }
    case 'rebet':
      optionalHeadQuery = !nextPage ? '?isOrderByEventDate=true' : ''
      break
  }

  return !nextPage
    ? `${apiUrlBase}/tickets/${activeTab}/head${optionalHeadQuery}`
    : apiUrlBase + nextPage
}
